import useSWR, { mutate } from 'swr';

import Configuration from '../configuration';
import {
  CampaignStatus,
  processCampaigns
} from '../shared/api-service';

// This export is designed to be used with 'useSWR()'.
export const fetcher = async (url: string, accessToken: string | null, method: string = 'GET', data: object = {}): Promise<any> => {
  let params: any = {
    method: method,
    cache: 'no-cache',
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    headers: (accessToken !== null) ? {
      accept: 'text/json',
      'Content-Type': 'text/json',
      Authorization: 'Bearer ' + accessToken,
    } :
      {
        accept: 'text/json',
        'Content-Type': 'text/json'
      }
  }

  // If using localhost then remove authorization param, similar to what we do in the api-service for accessing locally hosted APIs.
  if (url.indexOf('//localhost:') > 0) {
    delete params.headers.Authorization;
  }

  if (method.toUpperCase() !== "GET") {
    params.body = JSON.stringify(data);
  }

  let res = null;
  try {
    res = await fetch(url, params);
    if (!res.ok) {
      const error: any = new Error('An error occurred while fetching the data.');
      error.info = await res.json();
      error.status = res.status;
      console.log('error: ', error);
      throw error;
    }
  } catch (err: any) {
    const error: any = new Error('An error occurred while fetching the data..');
    error.info = err;
    error.status = err.status;
    console.log('error: ', error);
    throw error;
  }

  return res.json();
}


export function refetchCampaigns(status: CampaignStatus) {
  const url = Configuration.getCloudMessagingCampaignSearchURL() + '?status=' + status;
  mutate(url);
}

export function useCampaigns(status: CampaignStatus, accessToken: string) {
  // The back-end provides a POST REST API for GETTING campaigns based on a param instead of supporting a GET REST API with query param for GETTING campaigns.
  // This defeats the useSWR caching mechanism which is intended to be used with GETs.  To allow useSWR to properly cache the results from the data fetch
  // we need to add something to each URL to make them unique.  (The URL is used as a hash key.)  We add a query param of 'status' set to the status of
  // the campaign type we are requesting.  This ensures that each type of data retrieval (Pending, Scheduled, Submitted) uses a unique URL, and the query
  // param is ignored by the API itself so it is harmless.
  const url = Configuration.getCloudMessagingCampaignSearchURL() + '?status=' + status;
  const { data, error } = useSWR<any, any>(url, () => {
    return fetcher(url, accessToken, 'POST', { statusList: [status] })
  },
    {
      dedupingInterval: 2000,
      refreshInterval: 60000
    }
  );
  return {
    data: data ? processCampaigns(data) : undefined,
    isLoading: (error === undefined) && !data,
    isError: error
  }
}
